import React, { useState } from 'react';
import { IonRow, IonCol } from '@ionic/react';
import { ApplicationState } from '../store';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { simpleChannelType } from '../store/LocationStore';
import KidsEatFreeModal from '../modals/KidsEatFreeModal';
import Button from './Button';
import AllergenPopup from '../modals/AllergenPopup';
import {secondsToMinutes, useWaitTimes} from "../helpers/waitTimesHelper";
import { WaitTimesButton, WaitTimesModal } from "./wait-times/WaitTimesModal";
import {WaitTimesCheckoutModal} from "./wait-times/WaitTimesCheckoutModal";

const MopFooterBasketPage: React.FC = () => {
    const locationState = useSelector((state: ApplicationState) => state.location);
    const menuItemData = useSelector((state: ApplicationState) => state.menuItemData);
    const isLoading = useSelector((state: ApplicationState) => state?.basket?.isLoading);
    const basketStore = useSelector((state: ApplicationState) => state.basket);

    const upsells = useSelector((state: ApplicationState) => state.basket?.upsells);
    const upsellDone = useSelector((state: ApplicationState) => state.basket?.upsellDone);

    const [showKefModal, setShowKefModal] = useState<boolean>(false);
    const [showAllergenPopup, setShowAllergenPopup] = useState(false);

    const isLoggedIn = localStorage.getItem('isLoggedIn') === "true" ? true : false

    let history = useHistory();

    const { displayWaitTimes, anticipatedWaitTimeSeconds } = useWaitTimes();
    const [showWaitingModal, setShowWaitingModal] = useState<boolean>(false);
    const [showWaitingCheckoutModal, setShowWaitingCheckoutModal] = useState<boolean>(false);

    function showUpsellPage() {
        return upsells && upsells.length > 0 && !upsellDone
    }

    const handleCheckout = () => {
        if(secondsToMinutes(anticipatedWaitTimeSeconds ?? 0) >= 10) {
            setShowWaitingCheckoutModal(true);
        } else {
            handleKef();
        }
    }

    const handleAcceptWaitingCheckout = () => {
        setShowWaitingCheckoutModal(false);
        handleKef();
    }
    
    const handleKef = () => {
        if (basketStore?.basket.ageRestrictedDiscounts) {
            setShowKefModal(true);
        } else {
            handleCloseKef();
        }
    }

    const handleCloseKef = () => {
        setShowKefModal(false);

        if (showUpsellPage()) {
            history.push("/temptyou");
        } else {
            setShowAllergenPopup(true);
        }
    }

    function handleCloseAllergen()  {
        switch (locationState?.selectedChannel?.channelType) {
            case simpleChannelType.ClickAndCollect:
                isLoggedIn
                    ? history.push("/name-or-nickname")
                    : history.push("/enteremail");
                break;
            case simpleChannelType.TableOrder:
                isLoggedIn
                    ? history.push("/name-or-nickname")
                    : history.push("/tablenumber");
                break;
        }
    }

    return (
        <div className="MopFooterInner">
            { menuItemData?.menuItem &&
                <IonRow className="ion-align-items-center">
                    <IonCol size="6" className="FooterStoreWrapper">
                        <span className="CollectFrom">{locationState?.selectedChannel === undefined ? "Store" : locationState.selectedChannel.channelType === simpleChannelType.ClickAndCollect ? "Take away" : "Eat in" }</span><br/>
                        <span className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                        {locationState?.selectedStore?.takingMopOrders === false ? <span style={{ color: "#ff0" }}> - Order ahead not available</span> : null}
                        {displayWaitTimes && <WaitTimesButton onClick={() => setShowWaitingModal(true)} />}
                    </IonCol>
                    <IonCol size="6">
                        <Button
                            onClick={handleCheckout}
                            disabled={isLoading}
                            expand="block"
                            color="secondary"
                            size="small"
                            rounded
                        >
                            Checkout
                        </Button>
                    </IonCol>
                </IonRow>
            }

            {basketStore?.basket?.ageRestrictedDiscounts &&
                <KidsEatFreeModal
                    showModal={showKefModal}
                    closeModal={() => setShowKefModal(false)}
                    completeModal={handleCloseKef}
                    kidsMeals={basketStore.basket.ageRestrictedDiscounts}
                />
            }

            <AllergenPopup
                show={showAllergenPopup}
                close={() => setShowAllergenPopup(false)}
                accept={handleCloseAllergen}
            />
            <WaitTimesModal onDidDismiss={() => setShowWaitingModal(false)} showing={showWaitingModal} />
            <WaitTimesCheckoutModal onDidDismiss={() => setShowWaitingCheckoutModal(false)} onDidAccept={() => handleAcceptWaitingCheckout()} showing={showWaitingCheckoutModal} />
        </div>
    );
};

export default MopFooterBasketPage;
